<template>
  <div id="app" class="app">
    <router-view />
    <BlockUI v-if="this.$store.state.loading.blockUI > 0">
      <semipolar-spinner
       :animation-duration="2000"
       :size="100"
       :color="$themes.success" />
    </BlockUI>
  </div>
</template>

<script>
import Vue from 'vue'
import BlockUI from 'vue-blockui'
import { SemipolarSpinner } from 'epic-spinners'
Vue.use(BlockUI)

export default {
  name: 'app',
  components: {
    SemipolarSpinner,
  },
  computed: {
    isAuthenticated: function () {
      var x = this.$store.state.authentication.status.loggedIn

      if (typeof (x) !== 'undefined' && x !== null) {
        return true
      } else return false
    },
  },
}
</script>

<style lang="scss">
@import "@/sass/_colors.scss";
@import "../sass/main.scss";

.loading-container .loading{
  background-color: transparent !important;
  box-shadow: none !important;
}

body {
  height: 100%;

  #app {
    height: 100%;
  }
}
</style>
